<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="19"
    viewBox="0 0 12 19"
    fill="none"
  >
    <path
      d="M2.00043 16.8286L9.49164 2.00049"
      stroke="#8DA5C5"
      stroke-width="4"
      stroke-linecap="round"
    />
  </svg>
</template>

<script>
export default {};
</script>
